import React, { useEffect, useRef, useState } from 'react'
import { motion } from 'framer-motion';
import CloseButton from '../components/common/CloseButton';
import { RadioGroup } from '@headlessui/react'
import { HiCheckCircle } from 'react-icons/hi';
import emailjs from '@emailjs/browser';


const services = [
    {
        name: 'Web Development',
        desc: 'Starting at ₹2999'
    },
    {
        name: 'App Development',
        desc: 'Starting at ₹4999'
    },
    {
        name: 'Logo Design',
        desc: 'Starting at ₹999'
    },
]

const MyService = () => {

    const form = useRef();
    const [selected, setSelected] = useState(services[0])
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [contactNo, setContactNo] = useState('');
    const [focus, setFocus] = useState('');
    const [message, setMessage] = useState('');
    const [show, setShow] = useState(false)

    const sendEmail = (e) => {
        e.preventDefault();
        emailjs.sendForm('service_xb1a2w8', 'template_1ooifnw', form.current, 'idYZbq52Om5aVJ0M8')
            .then((result) => {
                console.log(result.text);
                setShow(true);
                setName('');
                setEmail('');
                setMessage('');
            }, (error) => {
                console.log(error.text);
            });
    }

    useEffect(() => {
        setTimeout(function () {
            setShow(false);
        }, 3000);
    }, []);

    console.log(selected)

    return (
        <motion.div
            className='h-full'
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0, opacity: 0 }}
            transition={{ duration: .4 }}
        >
            <div className='bg-white dark:bg-gray-900 p-5 rounded-custom z-40 '>
                <div className='flex justify-between items-center'>
                    <h4 className='text-center font-bold text-4xl text-slate-900 dark:text-white tracking-wide uppercase'>My <span className='text-skin-base'>Service</span></h4>
                    <CloseButton />
                </div>
                <div className='h-[calc(100vh-130px)] md:h-[calc(100vh-155px)] overflow-y-auto mt-4'>
                    {/* <h4 className='text-center font-bold text-4xl text-slate-900 dark:text-white tracking-wide uppercase'>Coming <span className='text-skin-base'>Soon</span></h4> */}

                    <div className='w-full'>
                        <form ref={form} onSubmit={sendEmail}>
                            <RadioGroup value={selected} onChange={setSelected}>
                                <label className='text-slate-600 dark:text-slate-400 text-lg font-semibold'>Project Type</label>
                                <RadioGroup.Label className="sr-only">Service</RadioGroup.Label>
                                <div className="flex flex-col md:flex-row justify-between items-center gap-3 mb-3">
                                    {services.map((item) => (
                                        <RadioGroup.Option
                                            key={item.name}
                                            value={item}
                                            className={({ active, checked }) =>
                                                `${active
                                                    ? ''
                                                    : ''
                                                }
                  ${checked ? 'bg-skin-fill bg-opacity-75 text-white' : 'bg-slate-100/50 dark:bg-slate-800/50'
                                                }
                    relative flex cursor-pointer rounded-custom px-5 py-4 focus:outline-none w-full`
                                            }
                                        >
                                            {({ active, checked }) => (
                                                <>
                                                    <div className="flex w-full items-center justify-between">
                                                        <div className="flex items-center">
                                                            <div className="text-sm">
                                                                <RadioGroup.Label
                                                                    as="p"
                                                                    className={`font-bold ${checked ? 'text-white' : 'text-gray-900 dark:text-slate-100'
                                                                        }`}
                                                                >
                                                                    {item.name}
                                                                </RadioGroup.Label>
                                                                <RadioGroup.Description
                                                                    as="span"
                                                                    className={`inline ${checked ? 'text-slate-300' : 'text-slate-500'
                                                                        }`}
                                                                >
                                                                    <span>
                                                                        {item.desc}
                                                                    </span>
                                                                </RadioGroup.Description>
                                                            </div>
                                                        </div>
                                                        {checked && (
                                                            <div className="shrink-0 text-white">
                                                                <HiCheckCircle className="h-6 w-6" />
                                                            </div>
                                                        )}
                                                    </div>
                                                </>
                                            )}
                                        </RadioGroup.Option>
                                    ))}
                                </div>
                            </RadioGroup>
                            <div className='flex flex-col md:flex-row md:gap-3'>
                                <div className='flex flex-col mb-3 w-full md:w-1/2'>
                                    <label className='text-slate-600 dark:text-slate-400 text-lg font-semibold'>Name</label>
                                    <input type="text" className='w-full p-2.5 text-lg rounded-custom border-2 border-slate-100 dark:border-slate-800 bg-slate-100/50 dark:bg-slate-800/50 text-slate-900 dark:text-white outline-none focus:border-2 focus:border-slate-200 dark:focus:border-slate-700' placeholder="Name" name="name" value={name} onChange={(e) => setName(e.preventDefault.value)} required />
                                </div>
                                <div className='flex flex-col mb-3 w-full md:w-1/2'>
                                    <label className='text-slate-600 dark:text-slate-400 text-lg font-semibold'>Contact Number</label>
                                    <input type="number" className='w-full p-2.5 text-lg rounded-custom border-2 border-slate-100 dark:border-slate-800 bg-slate-100/50 dark:bg-slate-800/50 text-slate-900 dark:text-white outline-none focus:border-2 focus:border-slate-200 dark:focus:border-slate-700' placeholder="Contact Number" name="contact_no" value={contactNo} onChange={(e) => setContactNo(e.preventDefault.value)} required />
                                </div>
                            </div>
                            <div className='flex flex-col md:flex-row md:gap-3'>
                                <div className='flex flex-col mb-3 w-full md:w-1/2'>
                                    <label className='text-slate-600 dark:text-slate-400 text-lg font-semibold'>Email Address</label>
                                    <input type="email" className='w-full p-2.5 text-lg rounded-custom border-2 border-slate-100 dark:border-slate-800 bg-slate-100/50 dark:bg-slate-800/50 text-slate-900 dark:text-white outline-none focus:border-2 focus:border-slate-200 dark:focus:border-slate-700' placeholder="Email Address" name="email" value={email} onChange={(e) => setEmail(e.preventDefault.value)} required />
                                </div>
                                <div className='flex flex-col mb-3 w-full md:w-1/2'>
                                    <label className='text-slate-600 dark:text-slate-400 text-lg font-semibold'>Focus</label>
                                    <select className='w-full p-3 text-lg rounded-custom border-2 border-slate-100 dark:border-slate-800 bg-slate-100/50 dark:bg-slate-800/50 text-slate-900 dark:text-white outline-none focus:border-2 focus:border-slate-200 dark:focus:border-slate-700' placeholder="Focus" name="focus" value={focus} onChange={(e) => setFocus(e.preventDefault.value)} required>
                                        <option value="">Select Focus</option>
                                        <option value="Affordable">Affordable</option>
                                        <option value="Best Quality">Best Quality</option>
                                        <option value="Cheapest">Cheapest</option>
                                    </select>
                                </div>
                            </div>
                            <div className='flex flex-col mb-5'>
                                <label className='text-slate-600 dark:text-slate-400 text-lg font-semibold'>Message</label>
                                <textarea rows="5" className="w-full p-2.5 text-lg rounded-custom border-2 border-slate-100 dark:border-slate-800 bg-slate-100/50 dark:bg-slate-800/50 text-slate-900 dark:text-white outline-none focus:border-2 focus:border-slate-200 dark:focus:border-slate-700" placeholder='Please describe your requirements in brief.' name="message" value={message} onChange={(e) => setMessage(e.preventDefault.value)} required></textarea>
                            </div>
                            <div className='flex justify-center md:justify-start mb-3'>
                                <button type="submit" className='bg-skin-fill text-white rounded-custom px-12 py-4 text-xl uppercase hover:opacity-90 font-semibold'>Submit</button>
                            </div>
                            {show ? <div className='w-full bg-green-500/20 p-2 text-green-600 dark:text-green-500 rounded-custom font-semibold text-lg text-center'>Thanks For Contacting Us! We Will Get In Touch With You Shortly.</div> : <div></div>}{" "}
                        </form>
                    </div>
                </div>
            </div>
        </motion.div>

    )
}

function CheckIcon(props) {
    return (
        <svg viewBox="0 0 24 24" fill="none" {...props}>
            <circle cx={12} cy={12} r={12} fill="#fff" opacity="0.2" />
            <path
                d="M7 13l3 3 7-7"
                stroke="#fff"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}


export default MyService